module.exports = "/_next/static/images/prefooter-integrations@2x_feb1556a706046c5ab7af3775bf18957.png";